interface StatusBadgeProps {
  status: string;
  className?: string;
}

const statusStyles: Record<string, string> = {
  调查中: "bg-primary-100 text-primary-800 border-primary-300",
  已通报: "bg-secondary-100 text-secondary-900 border-secondary-300",
  已辟谣: "bg-accent-100 text-accent-800 border-accent-300",
  已结案: "bg-background-200 text-foreground-700 border-background-300",
};

const dotStyles: Record<string, string> = {
  调查中: "bg-primary-500",
  已通报: "bg-secondary-500",
  已辟谣: "bg-accent-500",
  已结案: "bg-foreground-400",
};

export default function StatusBadge({ status, className = "" }: StatusBadgeProps) {
  const style = statusStyles[status] || statusStyles["已结案"];
  const dot = dotStyles[status] || dotStyles["已结案"];
  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-full border px-2.5 py-0.5 text-xs font-medium whitespace-nowrap ${style} ${className}`}
    >
      <span className={`w-1.5 h-1.5 rounded-full ${dot}`}></span>
      {status}
    </span>
  );
}